exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".float-style{float:right;margin-right:3px;margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6519a780!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/EmbeddedModuleComponent.vue
// module id = 902
// module chunks = 2